import React, { useEffect, useState } from 'react'
import { AuthenticatedHeader } from '../../components/Header/AuthenticatedHeader'
import Footer from '../../components/Footer/Footer'
import { ClassCard, CourseCard } from '../../components/Cards/GeneralCard/Card'
import gridClasses from '../../styles/grid.module.css'
import classes from './WishList.module.css'
import classNames from 'classnames'
import ToggleBar from '../../components/ToggleBar/ToggleBar'
import CardLoader from '../../components/loaders/CardLoader'
import { useDispatch, useSelector } from 'react-redux'
import { userSelectors } from '../../redux/userSlice'
import { wishListSelectors } from './wishListSlice'
import { getWishList } from './wishListApi'
import { getImageURL } from '../../util/functions'
import coursePlaceholder from '../../assets/images/course-placeholder.svg'
import classPlaceholder from '../../assets/images/class-placeholder.svg'
import notification from '../../components/Notification/notification'
import Empty from '../../components/Empty/Empty'
import emptyClass from '../../assets/images/empty-class.svg'
import emptyCourse from '../../assets/images/empty-course.svg'

const toggleBar = [
    {
        text: 'Classes',
        id: 'class',
    },
    {
        text: 'Courses',
        id: 'course',
    },
]

const WishList = () => {
    const [activeType, setActive] = useState('class')

    const dispatch = useDispatch()

    const user = useSelector(userSelectors.userDetails)
    const isFetching = useSelector(wishListSelectors.isFetching)
    const hasError = useSelector(wishListSelectors.hasError)
    const errorMessage = useSelector(wishListSelectors.errorMessage)
    const courses = useSelector(wishListSelectors.courses)
    const classesArray = useSelector(wishListSelectors.classes)

    useEffect(() => {
        if (hasError) {
            notification.failure({
                title: 'Error',
                description: errorMessage,
            })
        }
    }, [hasError, errorMessage])

    useEffect(() => {
        dispatch(getWishList(user.email))
    }, [dispatch, user.email])

    return (
        <>
            <AuthenticatedHeader />
            <div className={classes.topBar}>
                <div
                    className={classNames(
                        gridClasses.container,
                        gridClasses.containerTransparent
                    )}
                >
                    <ToggleBar
                        activeId={activeType}
                        changeActive={setActive}
                        links={toggleBar}
                    />
                </div>
            </div>

            <main className={classNames(classes.main, gridClasses.container)}>
                <h1 className={classes.header}>Wishlist</h1>
                <div className={classes.cards}>
                    {isFetching ? (
                        <>
                            <CardLoader />
                            <CardLoader />
                            <CardLoader />
                        </>
                    ) : (
                        <>
                            {activeType === 'class' ? (
                                <>
                                    {classesArray.map(({ data }) => (
                                        <ClassCard
                                            url={
                                                data.thumbnail
                                                    ? getImageURL(
                                                          data.thumbnail
                                                      )
                                                    : classPlaceholder
                                            }
                                            title={data.title}
                                            category={'HUMAN RESOURCES'}
                                            price={data.price}
                                            attendees={data.enrolled}
                                            date={data.startdate}
                                            time={data.starttime}
                                            classid={data.classid}
                                        />
                                    ))}
                                </>
                            ) : (
                                <>
                                    {courses.map(({ data }) => (
                                        <CourseCard
                                            url={
                                                data.thumbnail
                                                    ? getImageURL(
                                                          data.thumbnail
                                                      )
                                                    : coursePlaceholder
                                            }
                                            title={data.title}
                                            category={'HUMAN RESOURCES'}
                                            price={data.price}
                                            attendees={data.enrolled}
                                            coursecode={data.coursecode}
                                        />
                                    ))}
                                </>
                            )}
                        </>
                    )}
                </div>
                {!isFetching &&
                    activeType === 'class' &&
                    classesArray.length === 0 && (
                        <Empty
                            icon={emptyClass}
                            text={'No Classes in Wishlist'}
                        />
                    )}
                {!isFetching &&
                    activeType === 'course' &&
                    courses.length === 0 && (
                        <Empty
                            icon={emptyCourse}
                            text={'No Courses in Wishlist'}
                        />
                    )}
            </main>
            <Footer />
        </>
    )
}

export default WishList
